// ============================================================================
// KOREAN TRANSLATIONS - CHAPTER 6: 바울의 선교 여행
// ============================================================================
// 레벨 66-78 (13레벨, 39문제)

export const chapter6Translations = {
  name: "바울의 선교 여행",
  description: "땅끝까지...",
  
  spiritualWisdom: {
    principle: "복음은 모든 민족을 위한 것이며 전 세계에 전파되어야 한다",
    scripture: "가서 모든 민족을 제자로 삼으라 (마태복음 28:19)",
    application: "모든 그리스도인은 하나님이 두신 곳에서 그리스도의 증인이 되도록 부름받았다"
  },
  
  levels: {
    66: {
      name: "제1차 선교 여행",
      challenge: "내가 부른 일을 위하여 바나바와 사울을 따로 세우라...",
      easy: {
        question: "바울의 첫 번째 여행에 누가 동행했습니까?",
        options: ["베드로", "바나바", "실라", "디모데"],
        hint: "'위로의 아들'",
        funFact: "👥 바나바는 회심 후 바울을 받아들였다 - 섭리적 파트너십!"
      },
      medium: {
        question: "그들은 어느 도시에서 선교를 시작했습니까?",
        options: [
          "예루살렘",
          "시리아 안디옥",
          "다소",
          "다메섹"
        ],
        hint: "유대인과 이방인의 첫 혼합 교회",
        funFact: "🚢 안디옥: 서방 세계 복음화의 출발 항구!"
      },
      hard: {
        question: "이 첫 여행은 선교 전략에 대해 무엇을 드러냅니까?",
        options: [
          "자신의 지역에 머물러야 한다",
          "복음은 모든 문화적 경계를 초월한다",
          "유대인만 구원받을 수 있다",
          "선교는 선택 사항이다"
        ],
        hint: "메시지의 보편성에 관한 것",
        funFact: "🌊 지중해를 건너다 = 세계 복음화의 첫 걸음!"
      }
    },
    
    67: {
      name: "구브로에서 엘루마와",
      challenge: "모든 거짓과 악행이 가득한 자여, 마귀의 자식이여...",
      easy: {
        question: "구브로에서 바울에게 대항한 마술사는 누구입니까?",
        options: ["시몬", "엘루마", "아볼로", "알렉산더"],
        hint: "총독을 돌아서게 하려던 거짓 선지자",
        funFact: "🪄 복음과 마술의 첫 직접 대결!"
      },
      medium: {
        question: "바울은 엘루마에게 어떤 벌을 주었습니까?",
        options: [
          "그를 내쫓았다",
          "그를 일시적으로 눈멀게 했다",
          "그를 무시했다",
          "그와 논쟁했다"
        ],
        hint: "영적 눈을 열기 위한 일시적 실명",
        funFact: "👁️ 하나님의 아이러니: 영혼을 눈멀게 한 자가 일시적으로 눈이 멀다!"
      },
      hard: {
        question: "이 에피소드는 복음의 능력을 어떻게 보여줍니까?",
        options: [
          "폭력이 필요하다",
          "하나님의 진리가 거짓을 이긴다",
          "모든 마술사와 싸워야 한다",
          "바울은 복수심이 강했다"
        ],
        hint: "속임수에 대한 하나님의 권위에 관한 것",
        funFact: "⚡ 총독이 하나님의 능력을 보고 믿었다 - 효과적인 증거!"
      }
    },

    68: {
      name: "비시디아 안디옥에서",
      challenge: "하나님의 말씀이 먼저 너희에게 전해져야 했다...",
      easy: {
        question: "바울은 도시에 도착하면 먼저 어디서 설교했습니까?",
        options: [
          "공공 광장에서",
          "먼저 회당에서",
          "부자의 집에서",
          "이교 신전에서"
        ],
        hint: "그는 항상 자기 백성부터 시작했다",
        funFact: "🕍 선교 전략: 먼저 유대인에게, 다음으로 이방인에게!"
      },
      medium: {
        question: "유대인들은 바울의 메시지에 어떻게 반응했습니까?",
        options: [
          "모두가 받아들였다",
          "분열되었다: 어떤 이는 믿고, 어떤 이는 반대했다",
          "무관심했다",
          "즉시 그를 쫓아냈다"
        ],
        hint: "복음에 대한 전형적인 분열",
        funFact: "⚖️ 복음은 항상 나눈다: 받아들이거나 거부하거나, 무관심은 없다!"
      },
      hard: {
        question: "왜 바울은 이방인에게로 향합니까?",
        options: [
          "그는 이방인을 선호했다",
          "유대인의 거부가 이방인에게 문을 연다",
          "그것이 더 쉬웠다",
          "그는 사명을 포기했다"
        ],
        hint: "예언의 성취에 관한 것",
        funFact: "🚪 '이방인의 빛' - 이사야의 예언이 바울을 통해 성취!"
      }
    },

    69: {
      name: "루스드라에서의 치유",
      challenge: "신들이 인간의 모습으로 우리에게 내려오셨다!",
      easy: {
        question: "바울은 루스드라에서 무엇을 치유했습니까?",
        options: [
          "맹인",
          "나면서부터 걷지 못하는 사람",
          "귀머거리",
          "나병 환자"
        ],
        hint: "한 번도 걸어본 적이 없는 사람",
        funFact: "🦵 놀라운 기적: '네 발로 바로 일어서라!' - 치유의 믿음!"
      },
      medium: {
        question: "군중은 바울과 바나바를 누구라고 생각했습니까?",
        options: [
          "왕들",
          "신들 (제우스와 헤르메스)",
          "마술사들",
          "선지자들"
        ],
        hint: "그리스 신화의 신들",
        funFact: "⚡ 바나바 = 제우스 (위엄있는), 바울 = 헤르메스 (웅변가) - 문화적 오해!"
      },
      hard: {
        question: "바울은 이 우상숭배에 어떻게 반응했습니까?",
        options: [
          "영광을 받아들인다",
          "옷을 찢고 참 하나님을 전한다",
          "정중하게 침묵한다",
          "상황을 이용한다"
        ],
        hint: "우상숭배의 완전한 거부",
        funFact: "👔 옷을 찢다 = 우상숭배에 대한 유대인의 공포 - 완전한 정직!"
      }
    },

    70: {
      name: "돌에 맞음과 부활",
      challenge: "제자들이 그를 둘러싸고 있을 때, 그가 일어나서 성으로 들어갔다...",
      easy: {
        question: "루스드라 주민들은 바울에게 무엇을 했습니까?",
        options: [
          "투옥했다",
          "돌로 쳤다",
          "추방했다",
          "십자가에 못 박았다"
        ],
        hint: "전통적인 유대 형벌",
        funFact: "🪨 하루 만에 '신'에서 '죽은 자'로 - 인간 군중의 변덕!"
      },
      medium: {
        question: "바울은 돌에 맞은 후 무엇을 했습니까?",
        options: [
          "도시에서 도망쳤다",
          "숨었다",
          "일어나서 도시로 돌아갔다",
          "병원에 갔다"
        ],
        hint: "죽었다고 여겨진 후의 초자연적 용기",
        funFact: "💪 기적적인 부활 또는 하나님의 치유 - 믿을 수 없는 용기!"
      },
      hard: {
        question: "이 박해는 증거의 대가에 대해 무엇을 드러냅니까?",
        options: [
          "갈등을 피해야 한다",
          "그리스도를 위해 증거하는 것은 생명을 희생할 수 있다",
          "바울은 경솔했다",
          "박해는 무의미하다"
        ],
        hint: "진리 증거의 대가에 관한 것",
        funFact: "✝️ '많은 환난을 겪어 하나님 나라에 들어가야 한다' - 바울의 현실주의!"
      }
    },

    71: {
      name: "예루살렘 공의회",
      challenge: "할례를 받지 않으면 구원받을 수 없다...",
      easy: {
        question: "예루살렘 공의회에서 어떤 중요한 논쟁이 있었습니까?",
        options: [
          "세례",
          "개종한 이방인의 할례",
          "안식일",
          "헌금"
        ],
        hint: "그리스도인이 되려면 유대인이 되어야 하는가?",
        funFact: "✂️ 첫 번째 큰 위기: 그리스도교인가 유대-그리스도교인가?"
      },
      medium: {
        question: "공의회의 최종 결정은 무엇이었습니까?",
        options: [
          "할례는 의무",
          "이방인에게는 자유, 몇 가지 권고 사항 있음",
          "유대인으로부터 완전한 분리",
          "결정 연기"
        ],
        hint: "큰 제한 없이 이방인에게 개방",
        funFact: "🆓 역사적 혁명: 복음은 모세 율법에서 자유!"
      },
      hard: {
        question: "이 공의회는 보편적 교회에 어떤 중요성을 가집니까?",
        options: [
          "사소한 사건",
          "믿음만으로 구원의 보편성을 확립한다",
          "교회를 분열시킨다",
          "율법주의를 강화한다"
        ],
        hint: "보편적 교회의 기초에 관한 것",
        funFact: "🌍 이 결정이 없었다면 그리스도교는 유대교의 한 분파로 남았을 것이다!"
      }
    },

    72: {
      name: "제2차 여행: 디모데",
      challenge: "바울이 그를 데리고 가고자 하여 유대인을 위해 그에게 할례를 주었다...",
      easy: {
        question: "누가 젊은 협력자로 바울과 함께 했습니까?",
        options: ["마가", "누가", "디모데", "디도"],
        hint: "바울의 '사랑하는 아들'",
        funFact: "👦 디모데: 젊은 신동이 바울의 오른팔이 되다 - 성공적인 제자 훈련!"
      },
      medium: {
        question: "얻은 자유에도 불구하고 왜 바울은 디모데에게 할례를 주었습니까?",
        options: [
          "법적 의무 때문에",
          "유대인 사이의 선교 전략 때문에",
          "전통 때문에",
          "실수로"
        ],
        hint: "장애물을 피하기 위한 실용적 지혜",
        funFact: "🎯 지혜로운 자유: '모든 사람에게 모든 것이 되어 어떻게 해서든지 몇 사람을 구원하려 함'!"
      },
      hard: {
        question: "이 태도는 선교의 유연성을 어떻게 보여줍니까?",
        options: [
          "바울은 일관성이 없었다",
          "그는 복음을 타협하지 않고 방법을 적응시켰다",
          "그는 압력에 굴복했다",
          "그는 위선적이었다"
        ],
        hint: "상황적 지혜에 관한 것",
        funFact: "⚖️ 확고한 원칙, 유연한 방법 - 효과적인 증거의 기술!"
      }
    },

    73: {
      name: "마게도냐인의 환상",
      challenge: "마게도냐로 건너와서 우리를 도우라!",
      easy: {
        question: "바울은 밤에 환상에서 무엇을 보았습니까?",
        options: [
          "천사",
          "마게도냐인이 그를 부르고 있다",
          "예수께서 그에게 말씀하신다",
          "큰 빛"
        ],
        hint: "유럽에서의 도움의 외침",
        funFact: "🌉 결정적 환상: 복음이 유럽으로 건너가다 - 역사적 전환점!"
      },
      medium: {
        question: "복음화된 첫 번째 유럽 도시는 어디입니까?",
        options: [
          "아테네",
          "고린도",
          "빌립보",
          "데살로니가"
        ],
        hint: "마게도냐의 로마 식민지",
        funFact: "🏛️ 빌립보: 첫 번째 유럽 교회 - 대륙이 영원히 변화됨!"
      },
      hard: {
        question: "이 환상은 그리스도교 역사에 무엇을 상징합니까?",
        options: [
          "평범한 꿈",
          "서방으로의 섭리적 확장",
          "환각",
          "계획의 변경"
        ],
        hint: "역사를 인도하는 섭리에 관한 것",
        funFact: "🗺️ 이 환상이 없었다면 유럽은 이교로 남았을 것이다 - 하나님의 계획!"
      }
    },

    74: {
      name: "루디아, 첫 유럽인 개종자",
      challenge: "주께서 루디아의 마음을 열어 귀를 기울이게 하셨다...",
      easy: {
        question: "루디아의 직업은 무엇이었습니까?",
        options: [
          "제빵사",
          "자주 옷감 장사",
          "직조공",
          "도공"
        ],
        hint: "당시 고급품 거래",
        funFact: "🟣 자주색 = 매우 비싼 왕족의 색 - 루디아는 부유했다!"
      },
      medium: {
        question: "바울은 어디서 루디아를 만났습니까?",
        options: [
          "시장에서",
          "기도처인 강가에서",
          "그녀의 집에서",
          "회당에서"
        ],
        hint: "야외 기도처",
        funFact: "🏞️ 빌립보에는 회당이 없었다 - 전통에 따라 물가에서 기도!"
      },
      hard: {
        question: "루디아의 개종은 하나님의 일하심에 대해 무엇을 드러냅니까?",
        options: [
          "그녀는 소질이 있었다",
          "하나님은 말씀을 받을 준비가 된 마음을 여신다",
          "그것은 우연이었다",
          "바울은 설득력이 있었다"
        ],
        hint: "회심에서 하나님의 일하심에 관한 것",
        funFact: "💝 '주께서 그녀의 마음을 여셨다' - 하나님은 영혼을 준비하고 여신다!"
      }
    },

    75: {
      name: "빌립보에서의 투옥",
      challenge: "한밤중에 바울과 실라가 기도하며 하나님을 찬송하고 있었다...",
      easy: {
        question: "왜 바울과 실라는 투옥되었습니까?",
        options: [
          "도둑질",
          "귀신을 쫓아내어 공공 질서를 어지럽혔다",
          "신성 모독",
          "폭동"
        ],
        hint: "점치는 여종의 치유",
        funFact: "💸 영혼을 해방시키는 것은 착취자에게 비용이 든다 - 경제적 박해!"
      },
      medium: {
        question: "바울과 실라는 감옥에서 무엇을 했습니까?",
        options: [
          "불평했다",
          "기도하고 찬송했다",
          "변호 준비를 했다",
          "잤다"
        ],
        hint: "사슬에도 불구하고 찬송",
        funFact: "🎵 한밤중 감옥에서의 찬송 - 인상적인 흔들리지 않는 믿음!"
      },
      hard: {
        question: "그들의 태도는 어떻게 상황을 변화시켰습니까?",
        options: [
          "효과가 없었다",
          "지진 후 간수가 개종했다",
          "간수를 화나게 했다",
          "그들을 미치게 했다"
        ],
        hint: "모범으로 하는 강력한 증거",
        funFact: "🌍 지진 + 증거 = 간수와 그의 가족 개종!"
      }
    },

    76: {
      name: "아테네에서: 아레오바고",
      challenge: "너희가 알지 못하고 섬기는 것을 내가 너희에게 알게 하리라...",
      easy: {
        question: "바울은 아테네에서 어떤 제단을 언급했습니까?",
        options: [
          "제우스 신에게",
          "알지 못하는 신에게",
          "아폴로에게",
          "아테나에게"
        ],
        hint: "출발점이 된 신비로운 비문",
        funFact: "🏛️ '알지 못하는 신에게' - 그리스 철학과의 훌륭한 접점!"
      },
      medium: {
        question: "바울은 아테네에서 누구 앞에서 설교했습니까?",
        options: [
          "일반 군중",
          "아레오바고의 에피쿠로스와 스토아 철학자들",
          "신전 제사장들",
          "로마 황제"
        ],
        hint: "그리스의 지적 엘리트",
        funFact: "🧠 아레오바고 = 고대의 하버드 - 최고의 사상가들 앞의 바울!"
      },
      hard: {
        question: "아테네 사람들은 부활에 어떤 반응을 보였습니까?",
        options: [
          "만장일치의 수용",
          "분열: 조롱하는 자도 있고 관심을 보이는 자도 있었다",
          "전반적인 분노",
          "완전한 무관심"
        ],
        hint: "이 신비에 대한 지식인의 전형적인 반응",
        funFact: "🤔 부활 = 교만한 인간 지성에게는 걸림돌!"
      }
    },

    77: {
      name: "고린도: 천막 만드는 바울",
      challenge: "그들과 함께 살며 함께 일했다. 천막 만드는 것이 직업이었기 때문이다...",
      easy: {
        question: "바울은 생계를 위해 어떤 직업을 했습니까?",
        options: [
          "어부",
          "천막 만들기",
          "서기",
          "상인"
        ],
        hint: "그가 배운 수공예",
        funFact: "⛺ 바울: 사도·장인 - 그리스도인 사이의 수공예 존엄성!"
      },
      medium: {
        question: "바울은 고린도에서 누구의 집에 머물렀습니까?",
        options: [
          "여관",
          "아굴라와 브리스길라의 집",
          "총독의 집",
          "회당"
        ],
        hint: "그와 같은 천막 만드는 부부",
        funFact: "👫 아굴라와 브리스길라: 모범적인 선교사 부부 - 그리스도인의 환대!"
      },
      hard: {
        question: "왜 바울은 손으로 일했습니까?",
        options: [
          "경제적 필요만을 위해",
          "부담이 되지 않고 증거를 확실히 하기 위해",
          "가족 전통 때문에",
          "그 직업을 좋아했기 때문에"
        ],
        hint: "독립성과 신뢰성에 관한 것",
        funFact: "💼 경제적 자립 = 언론의 자유 - 바울은 누구에게도 의존하지 않았다!"
      }
    },

    78: {
      name: "에베소에서의 폭동",
      challenge: "위대하다, 에베소 사람의 아데미여!",
      easy: {
        question: "누가 에베소에서 바울에 대한 폭동을 일으켰습니까?",
        options: [
          "로마 당국",
          "은세공인 데메드리오와 장인들",
          "철학자들",
          "유대 제사장들"
        ],
        hint: "아데미 신전을 만들던 사람들",
        funFact: "🏛️ 역사상 첫 파업: 복음이 우상숭배 경제를 위협!"
      },
      medium: {
        question: "바울은 에베소에서 얼마나 오래 가르쳤습니까?",
        options: [
          "6개월",
          "1년",
          "2년",
          "3년"
        ],
        hint: "그의 가장 긴 선교 체류",
        funFact: "📅 3년간의 집중 교육 - 에베소는 중요한 선교 거점이 되었다!"
      },
      hard: {
        question: "이 폭동은 복음의 사회적 영향에 대해 무엇을 드러냅니까?",
        options: [
          "복음은 아무것도 바꾸지 않는다",
          "그것은 경제적·사회적 구조를 변혁한다",
          "종교에만 관계된다",
          "갈등을 피한다"
        ],
        hint: "깊은 사회 변혁에 관한 것",
        funFact: "💰 복음이 진전될 때 우상은 시장을 잃는다 - 경제적 영향!"
      }
    }
  }
};

export default chapter6Translations;
